import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

const tipSlice = createSlice({
  name: "tip",
  initialState: {
    tips: [],
    refetch: false,
  },
  reducers: {
    refetch: (state, action) => {
      state.refetch = action.payload;
    },
    setTips: (state, action) => {
      state.tips = action.payload;
    },
  },
});

export const { refetch, setTips } = tipSlice.actions;

export const getTips = (setLoading) => async (dispatch) => {
  try {
    const url = `${BASE_URL}/tip/get/tip/list/v1`;

    const { data } = await axios.get(url, {
      headers: {
        Authorization: localStorage.getItem("sgtoken"),
      },
    });

    dispatch(setTips(data.data));
    setLoading(false);
  } catch (error) {
    setLoading(false);
    toast.error(error.response.data.message, {
      position: "top-center",
      autoClose: 3000,
    });
  }
};
export default tipSlice.reducer;
